import { Container, Col, Row } from "react-bootstrap";
import Footer from "../../components/Layout/Footer/Footer";
import "../../components/Layout/Jumbotron/JumbotronII";
import "./schedule.css";

const Schedule = () => {
  const races = [
    {
      date: "2/18/2023",
      track: "Daytona Int'l Speedway",
      location: "Daytona Beach, FL.",
      time: "1:30pm",
      tv: "FS1",
    },
    {
      date: "3/10/2023",
      track: "Phoenix Raceway",
      location: "Avondale, AZ.",
      time: "8:00pm",
      tv: "FS2",
    },
    {
      date: "4/22/2023",
      track: "Talladega Superspeedway",
      location: "Talladega, AL.",
      time: "12:30pm",
      tv: "FS1",
    },
    {
      date: "5/6/2023",
      track: "Kansas Speedway",
      location: "Kansas City, KS.",
      time: "2:00pm",
      tv: "FS1",
    },
    {
      date: "5/26/2023",
      track: "Charlotte Motor Speedway",
      location: "Concord, NC.",
      time: "6:00pm",
      tv: "FS1",
    },
    {
      date: "6/17/2023",
      track: "Berlin Raceway",
      location: "Marne, MI.",
      time: "8:00pm",
      tv: "FS1/FLO",
    },
    {
      date: "6/24/2023",
      track: "Elko Speedway",
      location: "New Market, MN.",
      time: "9:00pm",
      tv: "FS2/FLO",
    },
    {
      date: "7/7/2023",
      track: "Mid-Ohio Sports Car Course",
      location: "Lexington, OH.",
      time: "6:00pm",
      tv: "FS1/FLO",
    },
    {
      date: "7/15/2023",
      track: "Iowa Speedway",
      location: "Newton, IA.",
      time: "8:00pm",
      tv: "FS2/FLO",
    },
    {
      date: "7/21/2023",
      track: "Pocono Raceway",
      location: "Long Pond, PA.",
      time: "6:00pm",
      tv: "FS1/FLO",
    },
    {
      date: "8/4/2023",
      track: "Michigan Int'l Speedway",
      location: "Brooklyn, MI.",
      time: "6:00pm",
      tv: "FS1/FLO",
    },
    {
      date: "8/11/2023",
      track: "Indianapolis Raceway Park",
      location: "Brownsburg, IN.",
      time: "6:00pm",
      tv: "FS1",
    },
    {
      date: "8/18/2023",
      track: "Watkins Glen Int'l",
      location: "Watkins Glen, NY.",
      time: "6:00pm",
      tv: "FS1",
    },
    {
      date: "8/20/2023",
      track: "Illinois State Fairgrounds",
      location: "Springfield, IL.",
      time: "2:00pm",
      tv: "FS1/FLO",
    },
    {
      date: "8/27/2023",
      track: "Milwaukee Mile",
      location: "West Allis, WI.",
      time: "1:00pm",
      tv: "FS1",
    },
    {
      date: "9/3/2023",
      track: "Du Quoin State Fairgrounds",
      location: "Du Quoin, IL.",
      time: "9:00pm",
      tv: "FS2/FLO",
    },
    {
      date: "9/8/2023",
      track: "Kansas Speedway",
      location: "Kansas City, KS.",
      time: "6:00pm",
      tv: "FS1",
    },
    {
      date: "9/14/2023",
      track: "Bristol Motor Speedway",
      location: "Bristol, TN.",
      time: "6:00pm",
      tv: "FS1",
    },
    {
      date: "9/30/2023",
      track: "Salem Speedway",
      location: "Salem, IN.",
      time: "4:00pm",
      tv: "FS2/FLO",
    },
    {
      date: "10/7/2023",
      track: "Toledo Speedway",
      location: "Toledo, OH.",
      time: "4:00pm",
      tv: "FS2/FLO",
    },
  ];

  return (
    <div>
      <Container className="JumboBGII" fluid>
        <div className="OverlayII">
          <Row>
            <Col className="text-center">
              <h1>SCHEDULE</h1>
            </Col>
          </Row>
        </div>
      </Container>
      <Container className="my-5 text-start">
        <Row>
          <Col>
            <Row className="my-1 fw-bold headers">
              <Col>DATE</Col>
              <Col>TRACK</Col>
              <Col>LOCATION</Col>
              <Col>TIME</Col>
              <Col>TV</Col>
            </Row>
            <hr />
            {races.map((races) => (
              <div>
                <Row className="my-3 fw-bold">
                  <Col>{races.date}</Col>
                  <Col>{races.track}</Col>
                  <Col>{races.location}</Col>
                  <Col>{races.time}</Col>
                  <Col>{races.tv}</Col>
                </Row>
                <hr />
              </div>
            ))}
          </Col>
        </Row>
        <Row>
          <Col className="my-5">
            <p className="fw-bold text-dark text-center">
              ALL TIMES EASTERN - SUBJECT TO CHANGE
            </p>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default Schedule;
